// extracted by mini-css-extract-plugin
module.exports = {"root":"TextImage__root___oUZjN"};